module.exports = {"language":{"flags":{"contribute_translations":"Contribuer aux traductions"}}};